export const SET_FULL_LIST = "SET_FULL_LIST";
export const ADD_REGIONS = "ADD_REGIONS";
export const ADD_SUPPLIERS = "ADD_SUPPLIERS";
export const ADD_LOCATIONS = "ADD_LOCATIONS";
